import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { withRouter } from 'react-router-dom';
import Iframe from 'react-iframe';
import ChatboxChi from './ChatBoxChi';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    body:{
        backgroundColor: 'grey',
    },
    sigPad:{
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
    },
    container: {
        // margin: theme.spacing.unit * 5,
        //width: '50%',
        //minwidth: '30%',
        width: 400,
        height: 250,
        maxHeight: 300,
        minHeight: 200,
        //top: '10%',
        // left: '10%',
    },
    sigContainer: {
        maxWidth: '100%',
        minwidth: '30%',
        height: '80%',
        alignItems:'left',
        backgroundColor: '#fff',
    },
    button: {
        //width: '100%',
    },
    sigImage: {
        backgroundSize: '200px 50px',
        width: '200px',
        height: '200px',
        backgroundColor: 'white',
    },
    pdfMargin:{
        // paddingRight: 10
    }
});

class ChatbotResponseChi extends Component{

    state = {
        trimmedDataURL: null,
        uniqueId: localStorage.getItem('token'),
    }

    openInNewWindow(caseId){
        console.log('openInNewWindow caseId: '+caseId);
        // window.open(__dirname+'chatbot_response.html?caseId='+caseId,"_self");
    }

    render(){
        const { classes } = this.props;
        let { trimmedDataURL } = this.state;

        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        console.log(`Chi FMF check ${userType} u ${this.state.uniqueId}`)
 
        let fileURL = __dirname + 'chatbot_response.html?caseId='+this.props.caseId
        console.log('ChatbotResponse caseId: '+this.props.caseId);
        return(
            <div className={classes.card2}>
            {   userType == 'respondent' && 
                <ChatboxChi caseId={this.props.caseId} style={{width:'100%', marginTop:'20px'}}/>
            }

            {userType !== 'respondent' && "Chatbot completed"}
   
            </div>  
        );
    }
}

const mapStateToProps = (state) => {
    return {
    isAuthenticated: state.auth.token !== null,
    //userId: state.auth.userId,
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    claimant_name: state.caseInfo.claimant_name,
    respondent_name: state.caseInfo.respondent_name,
    userType: state.caseInfo.userType,
    conversationId: state.caseInfo.conversationId,
    caseId: state.caseInfo.caseId,
    userType: state.caseInfo.userType,
    loadingCaseInfo: state.caseInfo.loading,
    loadingStepCompleted: state.onBoarding.loading,
    steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
    newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      onAuth: (username, password) => dispatch(actions.auth(username, password)),
      onBoardingStepCompletion: (uniqueId, caseId, userType, step_completed) => dispatch(actions.onBoardingStepCompletion(uniqueId, caseId, userType, step_completed)),
      getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
      getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
    }
  }

// export default withStyles(styles)(ChatbotResponse);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChatbotResponseChi)));